import { render, staticRenderFns } from "./MultipleChoiceElementSettings.vue?vue&type=template&id=02f19e5a&scoped=true&"
import script from "./MultipleChoiceElementSettings.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f19e5a",
  null
  
)

export default component.exports